import { BooleanFilter } from './BooleanFilter';

export default BooleanFilter;
